<template>
    <el-drawer title="关联周计划" custom-class="add-drawer" :visible.sync="drawer" direction="btt" :before-close="handleClose" size="95%" :wrapperClosable="false">
        <el-collapse v-model="planId" accordion @change="findPlanRelList" class="collapse-container" v-loading="loadData">
            <el-collapse-item :title="item.name" :name="item.id" v-for="item in planIdOptions" :key="item.id">
                <ul class="data-wrap" v-if="visitedData.length">
                    <li v-for="item in visitedData" :key="item.id">
                        <div class="text">
                            {{ item.visitDay }} {{ item.sidStr }}
                            <template v-if="item.target">：{{ item.target }}</template>
                        </div>
                        <el-button type="primary" icon="el-icon-check" plain @click="handleConfirm(item)">关联</el-button>
                    </li>
                </ul>
                <div style="text-align: center; color: #999;" v-else>暂无记录</div>
            </el-collapse-item>
        </el-collapse>
    </el-drawer>
</template>

<script>
import { findPlanListByUserId, findPlanRelListByPlanId } from "@/api/visit/index.js";

export default {
    name: 'weekPlanMobile',
    props: {
        visible: Boolean,
        schoolList: Array,
    },
    watch: {
        visible: {
            handler(val) {
                this.drawer = val;
                if (val) {
                    this.initPage();
                }
            },
            immediate: true,
        }
    },
    data() {
        return {
            loadData: false,
            drawer: false,
            planId: "",
            planIdOptions: [],
            visitedData: [],
        }
    },
    methods: {
        initPage() {
            this.findPlanListByUserIdApi();
        },
        // 查询周计划
        findPlanListByUserIdApi() {
            findPlanListByUserId().then((res) => {
                this.planIdOptions = [];
                if (res.data && res.data.length) {
                    this.planIdOptions = res.data;
                    this.planId = res.data[0].id;
                    this.findPlanRelList(res.data[0].id);
                }
            }).catch((err) => {
                this.$MessageBox.MessageWarning(err.data.msg);
            });
        },
        // 查询单个周计划下的拜访日志
        findPlanRelList(val) {
            this.planId = val;
            this.loadData = true;
            findPlanRelListByPlanId({ planId: val }).then((res) => {
                this.visitedData = res.data.map((item) => {
                    return {
                        ...item,
                        sidStr: this.getSchoolName(item.sid),
                    };
                });
                this.loadData = false;
            }).catch((err) => {
                this.visitedData = [];
                this.loadData = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            });
        },
        getSchoolName(id) {
            let name = "";
            this.schoolList.forEach((item) => {
                if (item.id == id) {
                    name = item.name;
                }
            });
            return name;
        },
        // 确认关联
        handleConfirm(row) {
            this.$emit('confirm', row);
            this.handleClose();
        },
        handleClose() {
            this.drawer = false;
            this.$emit('update:visible', false);
        },
    }
}
</script>

<style lang="scss" scoped>
/deep/ .collapse-container {
    .el-collapse-item__header {
        height: 44px;
        line-height: 44px;
        font-size: 14px;
    }
}
.data-wrap {
    .title {
        font-size: 1.3rem;
        font-weight: 600;
        color: #333;
    }
    > li {
        display: flex;
        width: 100%;
        height: 2rem;
        line-height: 2rem;
        margin-top: 6px;
        background-color: #f6fbff;
        border-radius: 4px;
        .text {
            width: calc(100% - 4rem);
            padding-left: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        /deep/ .el-button {
            width: 4rem;
            height: 1.6rem;
            margin-top: 0.2rem;
            margin-left: 0.2rem;
            padding: 0;
            font-size: 12px;
            background: transparent;
            border-radius: 2rem;
        }
    }
}
</style>